import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import { useContext, useState } from 'react';
import { authContext } from '../../FPERouter';

function ExitToApp() {
  const [open, setOpen] = useState(false);
  const auth = useContext(authContext);
  const handleClick = () => {
    setOpen(!open);
  }
  const closeDialog = () => {
    setOpen(false);
  }
  const logOut = () => {
    auth.signOut();
    window.location.reload();
  }
  return (
    <div>
      <Button onClick={handleClick}>
        <div className="header-item">
          <PowerSettingsNewIcon className="logout" ></PowerSettingsNewIcon>
          <span className="header-item-label">Logout</span>
        </div>
      </Button>
      <Dialog
        open={open}
        onClose={closeDialog}
      >
        <DialogContent>
          <DialogContentText>
            Are you sure logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">Cancel</Button>
          <Button onClick={logOut} color="primary">Logout</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ExitToApp;